import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthHandler';
import { useApiClient } from '../../service/API';
import SearchableDropdown from '../TicketComponents/SearchableDropdown';

function FilterForm({ notShowCreatedByFilter, filters, pageSize, onFilterChange, onPageSizeChange, onResetFilters, onApplyFilters }) {
    const navigate = useNavigate();
    const apiClient = useApiClient();
    const [boUserList, setBoUserList] = useState([]);
    const [foUserList, setFoUserList] = useState([]);
    const { userRoles } = useAuth();
    const fetchBoUserList = async () => {
        try {
          const userListGet = await apiClient.get('/users/bouser-list');
          console.log(userListGet);
          const userListWithAllOption = [{
            id: 'All',
            fullname: 'All',
            email: 'All'
          }, ...userListGet.data]; // Add the object at the first index
          setBoUserList(userListWithAllOption); // Update state with new list
        } catch (error) {
          // handleApiError(error, 'Error fetching user list. Please contact IT support.');
        }
    };

    const fetchFoUserList = async () => {
        try {
          const userListGet = await apiClient.get('/users/fouser-list');
          const userListWithAllOption = [{
            id: 'All',
            fullname: 'All',
            email: 'All'
          }, ...userListGet.data]; // Add the object at the first index
          setFoUserList(userListWithAllOption); // Update state with new list
        } catch (error) {
          // handleApiError(error, 'Error fetching user list. Please contact IT support.');
        }
    };

    useEffect(()=>{
        if(['FOUSER', 'TEAMLEAD', 'FOMANAGER', 'BOMANAGER','ADMIN'].some(role => userRoles.includes(role))){
            fetchBoUserList();
        }
        fetchFoUserList();
    },[]);

    return (
        <form className="mb-3">
        <div className="row g-3">
            <div className="col-md-6 col-lg-3">
            <label htmlFor="createdBy" className="form-label">Created By</label>
            <SearchableDropdown
                id="createdBy"
                name="createdBy"
                options={foUserList}
                selectedValue={filters.createdBy === ''?'All':filters.createdBy}
                onSelectedChange={(value)=>onFilterChange({name:"createdBy",value: value==='All'?'':value})}
                placeholder="Select user"
            />
            </div>
            {['FOUSER', 'TEAMLEAD', 'FOMANAGER', 'BOMANAGER','ADMIN'].some(role => userRoles.includes(role))&&<div className="col-md-6 col-lg-3">
            <label htmlFor="assignTo" className="form-label">Assign To</label>
            <SearchableDropdown
                id="assignTo"
                name="assignTo"
                options={
                    ['TEAMLEAD', 'BOMANAGER', 'ADMIN'].some(role => userRoles.includes(role))
                    ? boUserList
                    : boUserList.filter(u => !u.is_trainee)
                }
                selectedValue={filters.assignTo === ''?'All':filters.assignTo}
                onSelectedChange={(value)=>onFilterChange({name:"assignTo",value: value==='All'?'':value})}
                placeholder="Select user"
            />
            </div>}

            <div className="col-md-6 col-lg-3">
            <label htmlFor="startDate" className="form-label">Created Date (Start)</label>
            <input
                style={{ height: 38 }}
                type="date"
                id="startDate"
                name="startDate"
                placeholder="Created date (Start Date)"
                value={filters.startDate}
                onChange={onFilterChange}
                className="form-control"
                maxLength={255}  // Set the maximum length to 255
            />
            </div>
            
            <div className="col-md-6 col-lg-3">
            <label htmlFor="endDate" className="form-label">Created date (End)</label>
            <input
                style={{ height: 38 }}
                type="date"
                id="endDate"
                name="endDate"
                placeholder="Created date (End Date)"
                value={filters.endDate}
                onChange={onFilterChange}
                className="form-control"
                maxLength={255}  // Set the maximum length to 255
            />
            </div>

            <div className="col-md-6 col-lg-3">
            <label htmlFor="dropdownMenuButton" className="form-label">Page Size</label>
            <div className="dropdown custom-dropdown">
                <button className="btn btn-outline-secondary dropdown-toggle w-100" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                Page Size: {pageSize}
                <i className="bi bi-chevron-down ms-2"></i>
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li><a className="dropdown-item" href="#!" onClick={() => onPageSizeChange(10)}>10</a></li>
                <li><a className="dropdown-item" href="#!" onClick={() => onPageSizeChange(25)}>25</a></li>
                <li><a className="dropdown-item" href="#!" onClick={() => onPageSizeChange(50)}>50</a></li>
                <li><a className="dropdown-item" href="#!" onClick={() => onPageSizeChange(100)}>100</a></li>
                </ul>
            </div>
            </div>
                <div className="row gap-2 me-md-2 mt-2 ms-auto">
                    <button
                        type="button"
                        className="btn btn-primary col-md-2"
                        onClick={onApplyFilters}
                    >
                        Apply Filters
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary col-md-2"
                        onClick={onResetFilters}
                    >
                        Reset Filters
                    </button>
                    {['FOUSER', 'FOMANAGER', 'BOMANAGER','ADMIN'].some(role => userRoles.includes(role))&&<button
                    type="button"
                    className="btn btn-primary col-md-2 ms-auto"
                    onClick={() => navigate('/create-ticket')}
                    >
                    Create Ticket
                    </button>}
                </div>
            </div>
        </form>
    );
}

export default FilterForm;